<template>
	<div class="stamp-list">
		<form @submit.prevent="searching">
			<ManagingSection :columnCount="3">
				<ManagingBox title="검색" :horizontalMode="true">
					<Selector
						v-model="searchType"
						:optionList="searchTypeList"
					/>
					<input v-model="search" type="text" />
				</ManagingBox>
				<ManagingBox title="기간">
					<DateRange v-model="period" type="date" />
				</ManagingBox>
				<ManagingBox title="진행 상태">
					<Selector v-model="status" :optionList="statusList" />
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue" v-text="'검색'" />
				<button
					type="button"
					class="btn-main blue bordered"
					v-text="'초기화'"
					@click="initializing"
				/>
			</div>
		</form>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left stamp-list__total">
					검색 결과 {{ total }}건
				</div>
				<div class="section__info__right">
					<button
						class="section__info__items btn-excel"
						v-text="'CSV 다운'"
						@click="downloadingCsv"
					/>
					<Selector
						v-model="order"
						:optionList="orderList"
						class="section__info__items"
						@input="searching(0)"
					/>
				</div>
			</template>
			<table class="table-main stamp-list__table">
				<thead>
					<tr>
						<th
							v-for="item in thList"
							:key="item.id"
							:class="`stamp-list__table-item--${item.id}`"
							v-text="item.text"
						/>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" :key="item.id">
						<td
							:class="`stamp-list__table-item--${thList[0].id}`"
							v-text="item.id"
						/>
						<td :class="`stamp-list__table-item--${thList[1].id}`">
							<router-link
								:to="`/event/stamp/${item.id}`"
								class="link"
								>{{ item.title }}</router-link
							>
						</td>
						<td
							:class="`stamp-list__table-item--${thList[2].id}`"
							v-text="item.start_on"
						/>
						<td
							:class="`stamp-list__table-item--${thList[3].id}`"
							v-text="
								`${item.alternative} ${item.max_alternative}`
							"
						/>
						<td
							:class="`stamp-list__table-item--${thList[4].id}`"
							v-text="item.type"
						/>
						<td
							:class="`stamp-list__table-item--${thList[5].id}`"
							v-text="item.sum_winner"
						/>
						<td
							:class="`stamp-list__table-item--${thList[6].id}`"
							v-text="item.admin_nickName"
						/>
						<td
							:class="`stamp-list__table-item--${thList[7].id}`"
							v-text="item.hit"
						/>
						<td
							:class="`stamp-list__table-item--${thList[8].id}`"
							v-text="item.join_cnt"
						/>
						<td
							:class="`stamp-list__table-item--${thList[9].id}`"
							v-text="item.allDay_cnt"
						/>
						<td
							:class="`stamp-list__table-item--${thList[10].id}`"
							v-text="item.mission_cnt"
						/>
						<td
							:class="`stamp-list__table-item--${thList[11].id}`"
							v-text="item.comment_cnt"
						/>
						<td
							:class="`stamp-list__table-item--${thList[12].id}`"
							v-text="item.status"
						/>
						<td :class="`stamp-list__table-item--${thList[13].id}`">
							<button
								v-if="!item.join_cnt"
								class="btn red"
								v-text="'삭제'"
								@click="deleting(item.id)"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="total"
				:limit="limit"
				:offset="offset"
				:pageLengPerOne="10"
				@to="searching($event.offset)"
			/>
		</ManagingSection>
	</div>
</template>
<script>
	import moment from 'moment';
	import Util from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import Selector from '@/components/Selector.vue';
	import DateRange from '@/components/DateRange.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'EventStampList',
		components: {
			ManagingSection,
			ManagingBox,
			Selector,
			DateRange,
			PaginationBox,
		},
		data() {
			const searchTypeList = [
				{ value: 'name', name: '이벤트명' },
				{ value: 'id', name: '이벤트번호' },
			];
			const statusList = [
				{ value: null, name: '전체' },
				{ value: 1, name: '진행예정' },
				{ value: 2, name: '진행중' },
				{ value: 3, name: '종료' },
			];
			const orderList = [
				{ value: 1, name: '최근 등록순' },
				{ value: 2, name: '과거 등록순' },
				{ value: 3, name: '참여 많은순' },
				{ value: 4, name: '참여 적은순' },
				{ value: 5, name: '개근 많은순' },
				{ value: 6, name: '개근 적은순' },
				{ value: 7, name: '댓글 많은순' },
				{ value: 8, name: '댓글 적은순' },
			];

			return {
				searchTypeList,
				searchType: searchTypeList[0].value,
				search: '',
				period: { from: null, to: null },
				statusList,
				status: statusList[0].value,
				orderList,
				order: orderList[0].value,
				thList: [
					{ id: 'id', text: '이벤트번호' },
					{ id: 'title', text: '이벤트명' },
					{ id: 'start-on', text: '진행기간' },
					{ id: 'alt', text: '대체출석 미션' },
					{ id: 'type', text: '현물 이벤트 여부' },
					{ id: 'winner', text: '당첨인원' },
					{ id: 'admin', text: '등록자' },
					{ id: 'hit-cnt', text: '조회수' },
					{ id: 'join-cnt', text: '참여자수' },
					{ id: 'allday-cnt', text: '개근자수' },
					{ id: 'mission-cnt', text: '미션참여자수' },
					{ id: 'comment-cnt', text: '댓글' },
					{ id: 'status', text: '진행상태' },
					{ id: 'delete', text: '삭제' },
				],
				list: [],
				lastParams: {},
				total: 0,
				limit: 50,
				offset: 0,
				reqUrl: '',
			};
		},
		methods: {
			setQuery() {
				const query = [
					'searchType',
					'search',
					'from',
					'to',
					'status',
					'order',
					'offset',
				].reduce((acc, key) => {
					const value = this.period[key] || this[key];
					if (['from', 'to'].includes(key) && value) {
						acc[key] = value;
					} else if (
						(['searchType', 'status', 'order'].includes(key) &&
							this[`${key}List`][0].value !== value) ||
						value
					) {
						acc[key] = String(value);
					}
					return acc;
				}, {});
				this.$router.replace({ query }).catch(() => {});
			},
			getParams() {
				return [
					'search',
					'from',
					'to',
					'status',
					'order',
					'offset',
				].reduce(
					(acc, key) => {
						const value = this.period[key] || this[key];
						if (key === 'search' && value) {
							acc[this.searchType] =
								this.searchType === 'id' && isNaN(Number(value))
									? null
									: value;
						} else if (['from', 'to'].includes(key) && value) {
							acc[key === 'from' ? 'start_on' : 'end_on'] = value;
						} else {
							acc[key] = value;
						}
						return acc;
					},
					{
						limit: this.limit,
					}
				);
			},
			async getList(params) {
				this.$store.dispatch('stamp/setHasNew');
				const {
					data: {
						total: [total],
						stamps,
					},
					config: { url: reqUrl },
				} = await this.$axiosAdmin2.get('/v3/api/stamp', { params });
				return {
					total: total.cnt,
					list: stamps.map(item => ({
						...item,
						start_on: moment(item.start_on).format('YYYY-MM'),
						status: this.statusList.find(
							({ value }) => value === item.status
						).name,
					})),
					reqUrl,
				};
			},
			async setList() {
				try {
					const params = this.getParams();
					const { total, list } = await this.getList(params);
					this.total = total;
					this.list = list;
					this.lastParams = params;
				} catch (err) {
					console.error(err);
					alert('리스트 로드 실패! 개발팀에 문의 하세요.');
				}
			},
			searching(offset) {
				this.offset = typeof offset === 'number' ? offset : 0;
				this.setQuery();
				this.setList();
			},
			setFilter() {
				const query = this.$route.query;
				[
					'searchType',
					'search',
					'from',
					'to',
					'status',
					'order',
					'offset',
				].forEach(key => {
					const value = query[key];
					if (['searchType', 'status', 'order'].includes(key)) {
						this[key] = query.hasOwnProperty(key)
							? key === 'searchType'
								? value
								: Number(value)
							: this[`${key}List`][0].value;
					} else if ('search' === key) {
						this[key] = query.hasOwnProperty(key) ? value : '';
					} else if (['from', 'to'].includes(key)) {
						this.period[key] = query.hasOwnProperty(key)
							? value
							: null;
					} else if ('offset' === key) {
						this[key] = query.hasOwnProperty(key)
							? Number(value)
							: 0;
					}
				});
			},
			initializing() {
				this.$router.replace({ query: {} }).catch(() => {});
				this.setFilter();
			},
			async downloadingCsv() {
				try {
					const params = {
						...this.lastParams,
						limit: 99999,
					};
					const { list, reqUrl } = await this.getList(params);
					const rowsList = [
						list.map(item => [
							item.id,
							item.title,
							item.start_on,
							`${item.alternative} ${item.max_alternative}`,
							item.type,
							item.sum_winner,
							item.admin_nickName,
							item.hit,
							item.join_cnt,
							item.allDay_cnt,
							item.mission_cnt,
							item.comment_cnt,
							item.status,
						]),
					];
					const colsList = [
						this.thList
							.slice(0, this.thList.length - 1)
							.map(item => item.text),
					];
					Util.getCsv(
						rowsList,
						undefined,
						colsList,
						`출석체크 이벤트 리스트_${Date.now()}`,
						reqUrl
					);
				} catch (err) {
					console.error(err);
					alert('CSV 다운 실패! 개발팀에 문의하세요.');
				}
			},
			async deleting(id) {
				try {
					if (!confirm(`${id} 출석체크 삭제 하시겠습니까?`)) return;
					await this.$axiosAdmin2.delete(`/v3/api/stamp/${id}`);
				} catch (err) {
					console.error(err);
					alert('삭제 실패! 개발팀에 문의하세요.');
				} finally {
					this.setList();
				}
			},
		},
		mounted() {
			this.setFilter();
			this.setList();
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-list {
		&__total {
			font-weight: 700;
		}

		&__table {
			table-layout: fixed;
		}

		&__table-item--id {
			width: 80px;
			padding: 0;
		}

		&__table-item--title {
		}

		&__table-item--start-on {
			width: 80px;
			padding: 0;
		}

		&__table-item--alt {
			width: 100px;
			padding: 0;
		}

		&__table-item--type {
			width: 110px;
			padding: 0;
		}

		&__table-item--winner {
			width: 80px;
			padding: 0;
		}

		&__table-item--admin {
			width: 80px;
			padding: 0;
		}

		&__table-item--hit-cnt {
			width: 80px;
			padding: 0;
		}

		&__table-item--join-cnt {
			width: 80px;
			padding: 0;
		}

		&__table-item--allday-cnt {
			width: 80px;
			padding: 0;
		}

		&__table-item--mission-cnt {
			width: 80px;
			padding: 0;
		}

		&__table-item--comment-cnt {
			width: 80px;
			padding: 0;
		}

		&__table-item--status {
			width: 80px;
			padding: 0;
		}

		&__table-item--delete {
			width: 80px;
			padding: 0;
		}
	}
</style>
